
import { backendExceptionHandler } from "@/mixins";
import FinAgentService from '@/service/FinAgentService';

export default {
    name: "DeleteSnippetModal",

    mixins: [backendExceptionHandler],
    

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        snippetIds: {
            type: Array,
            default: () => [],
        }
    },

    emits: ['input', 'success'],

    data() {
        return {
            errorMessage: null,
            isLoading: false,
        }
    },

    computed: {
        isSubmitDisabled() {
            return this.isLoading;
        },
        isMassDelete() {
            return this.snippetIds.length > 1;
        }
    },

    created() {
        this.finAgentService = new FinAgentService(this.$axios);
    },

    methods: {
        closeModal() {
            this.$emit('input', false);
        },

        async handleDelete() {
            if (this.isSubmitDisabled) {
                return;
            }
            this.isLoading = true;

            try {
                if (this.isMassDelete) {
                    await this.finAgentService.massDeleteSnippets(this.snippetIds);
                } else {
                    await this.finAgentService.deleteSnippet(this.snippetIds[0]);
                }
                this.$emit('success', this.snippetIds);
                this.$store.commit('snackbar/updateType', 'success');
                this.$store.commit('snackbar/updateMessage', this.$t('component.deleteSnippetModal.success'));
                this.closeModal();
            } catch (error) {
                this.handleBackendException(error, this.$t('component.deleteSnippetModal.error'));
                this.$store.commit('snackbar/updateType', 'error');
                this.$store.commit('snackbar/updateMessage', this.errorMessage);
            } finally {
                this.isLoading = false;
            }
        },
    },
}
